@let texts = resourcesService.languageFile.value();
<div id="gis-container">
  <!--suppress AngularUndefinedBinding -->
  <gm-modal #gmModal
            [hidden]="!store.error()"
            [title]="texts.errors.serverError"
            [content]="store.error()"
            notificationState="error"
            popup></gm-modal>

  @if (store.phase() === 'starting') {
    <gis-starting-screen/>
  }

  @if (store.phase() === 'playing') {
    <gis-playing-screen/>
  }

  <div id="map-container" #mapContainer
       [style.flex-basis]="mapFlexBasis"
       [class]="{'is-starting': store.phase() === 'starting', hidden: store.phase() === 'gameOver'}">
    @if (store.startGameLayerId()) {
      <gis-map #mapComponent [gameState]="store.phase()"/>
    }
  </div>

  @if (store.phase() === 'gameOver') {
    <gis-game-over-screen/>
  }
</div>
